import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ProfileSidebar from '../../components/Profile/ProfileSidebar';
import ProfileMobileSubNav from '../../components/Profile/ProfileMobileSubNav';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useUser } from '../../contexts/user';
import { useCart } from '../../contexts/cart';
import { getApiErrorMessage } from '../../utils/apiError';
import log from '../../utils/logger';
import api from '../../api/api';
import useToast from '../../hooks/useToast';
import Toast from '../../components/Toast';

const ChangeLanguage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'en');
  const { idToken, user, updateProfile, adminImpersonate, logout } = useUser();
  const { clearCart } = useCart();
  const { toastMessage, toastType, showToast } = useToast();

  useEffect(() => {
    if (user?.language) {
      setSelectedLanguage(user.language);
    }
  }, [user]);

  const handleLanguageSelection = (lng) => {
    setSelectedLanguage(lng);
  };

  const handleSave = async () => {
    i18n.changeLanguage(selectedLanguage);

    try {
      await api.put(
        '/user/language',
        { language: selectedLanguage },
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );

      updateProfile({ language: selectedLanguage });

    } catch (error) {
      log.error('Error changing language', error);
      const message = error.response?.data?.error || '';
      if (message === 'TOKEN_EXPIRED' || message === 'INVALID_ID_TOKEN') {
        navigate('/home');
        sessionStorage.setItem('sessionExpired', 'true');
        sessionStorage.setItem(
          'toast',
          JSON.stringify({
            message: t('sessionExpiredMessage'),
            type: 'error',
          }),
        );
        logout();
        clearCart();
      } else {
        showToast(getApiErrorMessage(error, t), 'error');
      }
    }
  };

  if ((!idToken || !user) && !adminImpersonate) {
    return (
      <>
        <div className="flex flex-col min-h-dvh">
          <Header />
          <ProfileMobileSubNav />
          <section className="pt-20 lg:px-3 pb-40">
            <div className="max-w-[1220px] w-full mx-auto flex gap-4 lg:gap-20">
              <div className="hidden lg:block">
                <ProfileSidebar />
              </div>
              <div className="flex-1 flex justify-center items-center">
                <p className="text-[#999]">{t('loginRequiredMessage')}</p>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div className="flex flex-col min-h-dvh">
        <Header />
        <ProfileMobileSubNav />

        <section className='pt-20 px-3 pb-40'>
          <div className='max-w-[1220px] w-full mx-auto flex gap-4 lg:gap-20'>
            <div className='hidden lg:block'>
              <ProfileSidebar />
            </div>

            <div className='flex-1 elevation-2 rounded h-fit'>
              {/* card header  */}
              <div className='py-3 px-4 text-[#000000DE] text-xl font-semibold'>
                {t('Choose Language Title')}
              </div>

              {/* select language */}
              <ul className='px-4 pb-4'>
                <li
                  className='flex items-center justify-between py-3 text-sm text-[#000000DE] cursor-pointer'
                  onClick={() => handleLanguageSelection('en')}
                >
                  English
                  <input
                    type="radio"
                    className='cursor-pointer'
                    checked={selectedLanguage === 'en'}
                    onChange={() => handleLanguageSelection('en')}
                  />
                </li>
                <li
                  className='flex items-center justify-between py-3 text-sm text-[#000000DE] cursor-pointer'
                  onClick={() => handleLanguageSelection('fr')}
                >
                  French
                  <input
                    type="radio"
                    className='cursor-pointer'
                    checked={selectedLanguage === 'fr'}
                    onChange={() => handleLanguageSelection('fr')}
                  />
                </li>
              </ul>

              {/* save btn  */}
              <div className='flex justify-end p-4'>
                <button className='text-[#0B1223] text-sm uppercase font-semibold' onClick={handleSave}>
                  {t('Save')}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      <Toast message={toastMessage} type={toastType} />
    </>
  );
};

export default ChangeLanguage;
